import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'

export const getComeFarePer = gql`
  ${seoFragment}
  query GetComeFarePer($slug: [String], $site: [String]) {
    comeFarePerEntries(slug: $slug, site: $site) {
      ... on comeFarePer_Entry {
        id
        title
        localized {
          slug
          language
        }
        seo {
          ...SeoFragment
        }
        sezioneContenutoPagina {
          ... on testo_Entry {
            text
          }
          ... on immagine_Entry {
            custom: immagine @transform(format: "webp", width: 1800) {
              id
              url
              width
              height
              title
            }
          }
          ... on immagineTradotta_Entry {
            custom: immagineTradotta @transform(format: "webp", width: 1800) {
              id
              url
              width
              height
              title
            }
          }
        }
        titoloCarosello
        proposte(site: "it") {
          id
          title
          ... on vino_Entry {
            id
            typeHandle
            sezioneBio
            descrizioneProdotto
            descrizioneProdottoEn
            descrizioneProdottoEs
            descrizioneProdottoFr
            filtroTipologiaVino(site: $site) {
              title
            }
            portrait: immagine
              @transform(format: "webp", width: 1200, height: 1400) {
              id
              url
              width
              srcset(sizes: ["750w", "1000w"])
              height
              title
            }
            slug
          }
          ... on birra_Entry {
            id
            typeHandle
            sezioneBio
            descrizioneProdotto
            descrizioneProdottoEn
            descrizioneProdottoEs
            descrizioneProdottoFr
            filtroStiliBirra(site: $site) {
              title
            }
            portrait: immagine
              @transform(format: "webp", width: 1200, height: 1400) {
              id
              url
              width
              srcset(sizes: ["750w", "1000w"])
              height
              title
            }
            slug
          }
        }
      }
    }
  }
`
